﻿import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import theme from "./Select.module.sass";

const Select = forwardRef(
  ({ choices, error, placeholder = 'Select an option', ...others }, ref) => {
    // FormItem drives this through react-hook-form's Controller, which starts every
    // field at ''. A controlled <select> whose value matches no option still renders
    // the FIRST option as the visible one, while the form keeps holding ''. That is
    // why the login branch modal showed "Online" and then refused to submit with
    // "Please select an application": nothing was ever selected, it only looked that
    // way. Under react-hook-form 6 the field was uncontrolled and the library read
    // the DOM, so the displayed option was the submitted one.
    //
    // Render an explicit empty option in that state so what the user sees matches
    // what the form holds. A field that already has a value, or whose choices include
    // an empty one, is left alone.
    const needsPlaceholder =
      (others.value === '' || others.value === undefined) &&
      !choices.some(({ value }) => value === '' || value === null);

    return (
      <div
        className={classNames(theme.Select, {
          [theme.InputError]: error,
        })}
      >
        <select ref={ref} {...others}>
          {needsPlaceholder && <option value="">{placeholder}</option>}
          {choices.map(({ value, title }) => (
            <option key={value} id={value} size="small" value={value}>
              {title}
            </option>
          ))}
        </select>
        {error && <span className={theme.ErrorText}>{error}</span>}
      </div>
    );
  },
);

Select.propTypes = {
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  error: PropTypes.string,
  placeholder: PropTypes.string,
};

export default Select;
